import {Button, Col, Form, Row} from "antd";
import {InputFields} from "components/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {Notification} from "components/common";
import {
  columnsBranch,
  columnsKhoDuoc,
  columnsKhoKinh,
  columnsKhoVT,
  columnsRole,
  fields as fieldsInit,
} from "./config";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import {isValuable, objectWithoutProperties, randomId} from "helper/common";
import {authenticationService} from "api";
import {getListStore as getListStoreDuoc} from "redux/reducer/pharmacyStore";
import {getListStore as getListStoreKinh} from "redux/reducer/glassStore";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {getSuppliesStoreAPI} from "redux/reducer/medicalSupplies";
import {tabKeys} from "types/enums";
const ModalUser = forwardRef((props: any, ref) => {
  const dispatch = useAppDispatch();
  const {id, setId, getListUser} = props;
  const [form] = Form.useForm<any>();
  const listStoreDuoc = useAppSelector(state => state.pharmacyStore.listStore);
  const listStoreKinh = useAppSelector(state => state.glassStore.listStore);
  const listStoreVT = useAppSelector(
    state => state.medicalSuppliesReducer.suppliesStoreList
  );
  const [detail, setDetail] = useState();
  const [listRole, setListRole] = useState<any>();
  const [listBranch, setListBranch] = useState<any>();

  const [dataRole, setDataRole] = useState<any[]>([]);
  const [dataKhoDuoc, setDataKhoDuoc] = useState<any[]>([]);
  const [dataKhoKinh, setDataKhoKinh] = useState<any[]>([]);
  const [dataKhoVT, setDataKhoVT] = useState<any[]>([]);
  const [dataBranch, setDataBranch] = useState<any[]>([]);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const [fields, setFields] = useState<any>(fieldsInit);
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      console.log("reset");
      form.resetFields();
    },
  }));
  useEffect(() => {
    const getAllRole = async () => {
      try {
        const res = await authenticationService.getListRole();
        setListRole(res);
      } catch (error) {}
    };
    const getAllBranch = async () => {
      try {
        const res = await authenticationService.getListBranch();
        setListBranch(res);
      } catch (error) {}
    };
    if (activeTab == tabKeys.AUTHORIZATION.ACCOUNT) {
      getAllRole();
      getAllBranch();
    }
  }, [activeTab]);
  useEffect(() => {
    dispatch(getListStoreDuoc());
    dispatch(getListStoreKinh());
    dispatch(getSuppliesStoreAPI({}));
  }, []);
  useEffect(() => {
    const getDetailUser = async id => {
      try {
        const res = await authenticationService.getDetailUser(id);
        setDetail(res);
      } catch (error) {}
    };
    console.log(id);
    if (id != null) {
      getDetailUser(id);
    } else {
      setDetail(null);
      setTable("listBranch", []);
      setTable("listKhoDuoc", []);
      setTable("listKhoKinh", []);
      setTable("listKhoVT", []);
      setTable("listRole", []);
    }
  }, [id]);
  useEffect(() => {
    fieldsInit.find(e => e.name == "username").disabled = isValuable(id);
    fieldsInit.find(e => e.name == "pass").hide = isValuable(id);
    fieldsInit.find(e => e.name == "pass").rules = isValuable(id)
      ? []
      : [{required: true, message: "Chưa nhập mật khẩu"}];
    setFields(fieldsInit);
  }, [id]);
  const setTable = (
    nameTable:
      | "listBranch"
      | "listKhoDuoc"
      | "listKhoKinh"
      | "listKhoVT"
      | "listRole",
    data
  ) => {
    let funcSetData;
    switch (nameTable) {
      case "listBranch":
        funcSetData = setDataBranch;
        break;
      case "listKhoDuoc":
        funcSetData = setDataKhoDuoc;
        break;
      case "listKhoKinh":
        funcSetData = setDataKhoKinh;
        break;
      case "listKhoVT":
        funcSetData = setDataKhoVT;
        break;
      case "listRole":
        funcSetData = setDataRole;
        break;

      default:
        break;
    }
    let formatData = data?.map(e => {
      if (nameTable != "listRole") {
        return {id: e, key: randomId()};
      } else {
        return {...e, key: randomId()};
      }
    });
    funcSetData(formatData);
    form.setFieldValue(nameTable, formatData);
  };
  const convertCombineStringToArray = combineStringArray => {
    const combineString = combineStringArray?.[0];
    const array = combineStringArray?.[0] ? combineString?.split(";") : [];
    return array;
  };
  useEffect(() => {
    const setFieldsValue = detail => {
      if (detail) {
        form.setFieldsValue(detail?.dto);
        setTable(
          "listBranch",
          convertCombineStringToArray(detail?.dto?.attributes?.chinhanh)
        );
        setTable(
          "listKhoDuoc",
          convertCombineStringToArray(detail?.dto?.attributes?.kho_duoc)
        );
        setTable(
          "listKhoKinh",
          convertCombineStringToArray(detail?.dto?.attributes?.kho_kinh)
        );
        setTable(
          "listKhoVT",
          convertCombineStringToArray(detail?.dto?.attributes?.kho_vtyt)
        );
        setTable("listRole", detail?.listRoles);
      } else {
        form.resetFields();
      }
    };
    setFieldsValue(detail);
  }, [detail]);
  const getRoleById = id => {
    const name = listRole?.find(e => e?.id == id)?.name;
    const data = {id: id, name: name};
    return data;
  };
  // const addRole = async role => {
  //   try {
  //     const data = getRoleById(role?.id);
  //     await authenticationService.postRole(id, data);
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi");
  //   }
  // };
  // const removeRole = async role => {
  //   try {
  //     const data = getRoleById(role?.id);
  //     await authenticationService.removeRole(id, data);
  //   } catch (error) {
  //     Notification("error", "Đã có lỗi");
  //   }
  // };
  const convertArrayToCombineString = array => {
    const combineString = array?.map?.(item => item?.id)?.join(";");
    const arrayString = [combineString];
    return array?.length > 0 ? arrayString : null;
  };
  const postUser = async () => {
    try {
      const formValue = await form.validateFields();
      const params = objectWithoutProperties(formValue, [
        "listRole",
        "listBranch",
        "listKhoDuoc",
        "listKhoKinh",
        "listKhoVT",
      ]);
      const res = await authenticationService.postUser(params);
      setId(res?.id);
      updateUser(res?.id);
      resetPassword(res?.id, formValue?.pass);
      Notification("success", "Đã tạo tài khoản thành công");
      getListUser();
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };
  const resetPassword = async (id, password) => {
    try {
      const params = {value: password, temporary: false, type: "password"};
      await authenticationService.resetPass(id, params);
    } catch (error) {}
  };
  const updateUser = async idUser => {
    try {
      const formValue = await form.validateFields();
      const params = {
        dto: {
          id: idUser,
          ...objectWithoutProperties(formValue, [
            "listRole",
            "listBranch",
            "listKhoDuoc",
            "listKhoKinh",
            "listKhoVT",
            "pass",
          ]),
          attributes: {
            chinhanh: convertArrayToCombineString(formValue?.listBranch),
            kho_vtyt: convertArrayToCombineString(formValue?.listKhoVT),
            kho_kinh: convertArrayToCombineString(formValue?.listKhoKinh),
            kho_duoc: convertArrayToCombineString(formValue?.listKhoDuoc),
          },
        },
        listRoles: listRole?.filter(e =>
          formValue?.listRole?.some(e1 => e1?.id == e?.id)
        ),
      };
      console.log(params);

      const res = await authenticationService.updateUser(params);
      Notification("success", res);
    } catch (error) {
      Notification("error", error?.response?.data ?? "Đã có lỗi");
    }
  };

  return (
    <div>
      <Form form={form}>
        <Row gutter={[4, 4]}>
          <InputFields data={fields}></InputFields>
        </Row>
        <Row style={{width: "100%", marginTop: 4}} gutter={[4, 4]}>
          <Col span={8}>
            <TableInputAdd
              data={dataRole}
              setData={setDataRole}
              name="listRole"
              form={form}
              column={columnsRole}
              options={listRole}
            ></TableInputAdd>
          </Col>
          <Col span={8}>
            <TableInputAdd
              data={dataBranch}
              setData={setDataBranch}
              name="listBranch"
              form={form}
              column={columnsBranch}
              options={listBranch}
            ></TableInputAdd>
          </Col>
          <Col span={8}>
            <TableInputAdd
              data={dataKhoDuoc}
              setData={setDataKhoDuoc}
              name="listKhoDuoc"
              form={form}
              column={columnsKhoDuoc}
              options={listStoreDuoc}
            ></TableInputAdd>
          </Col>
          <Col span={8}>
            <TableInputAdd
              data={dataKhoKinh}
              setData={setDataKhoKinh}
              name="listKhoKinh"
              form={form}
              column={columnsKhoKinh}
              options={listStoreKinh}
            ></TableInputAdd>
          </Col>
          <Col span={8}>
            <TableInputAdd
              data={dataKhoVT}
              setData={setDataKhoVT}
              name="listKhoVT"
              form={form}
              column={columnsKhoVT}
              options={listStoreVT}
            ></TableInputAdd>
          </Col>
        </Row>
        <Row justify={"end"}>
          <Button
            type="primary"
            onClick={() => {
              id == null ? postUser() : updateUser(id);
            }}
          >
            Lưu
          </Button>
        </Row>
      </Form>

      <div></div>
    </div>
  );
});

export default ModalUser;
